import {faSearch} from '@fortawesome/free-solid-svg-icons/faSearch';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Mutation} from 'react-apollo';
import {Button, Col, Container, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import {dateFormatFR} from '../../../utils';
import Error from '../../../common/components/Error/Error';
import {AttributeDiv} from '../../../common/components/layout/InputCol';
import Panel from '../../../common/components/Panel';
import PopIn from '../../../common/components/PopIn';
import {TitleButton} from '../../../common/components/StyledComp';
import TicketPreview from './TicketPreview';
import TicketRating from './TicketRating';
import {userBarcode} from './TicketDetailsModal';


const FullTextArea = styled.textarea`
  width: 100%;
  padding: 10px;
`;

const ButtonLeft = styled(Button)`
  margin-left: 15px;
`;

export const GRAPHQL_MUTATION_ADD_RECEIPT_COMMENT = gql`
    mutation addReceiptComment($receiptCommentInput: AddReceiptCommentInput!) {
        addReceiptComment(receiptCommentInput: $receiptCommentInput) {
            id
            comments {
                id
                review
            }
        }
    }
`;

const ReceiptDetailsReviewMerchant = ({receipt, t}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [responseMerchant, setResponseMerchant] = useState('');
  const translationVars = {
    date: dateFormatFR({date: receipt.createdAt}),
    user: userBarcode(t, receipt.user),
  };

  const postComment = addReceiptComment => {
    if (responseMerchant !== '') {
      addReceiptComment({
        variables: {
          receiptCommentInput: {
            receiptId: receipt.id,
            review: responseMerchant,
          },
        },
      })
        .then(res => {
          setModalVisible(false);
        }).catch(error => {
          console.error(error);
        });
    }
  };

  return (
    <div>
      <ButtonLeft className="btn-update" onClick={() => setModalVisible(true)}>
        <FontAwesomeIcon icon={faSearch} color="#329aef" size="sm"/>
      </ButtonLeft>

      <PopIn headerColor={'#323232'} titleColor={'#ffffff'} visible={modalVisible} setModalVisible={setModalVisible}
        title={t('receiptFrom', translationVars)}>

        <Mutation mutation={GRAPHQL_MUTATION_ADD_RECEIPT_COMMENT}>
          {(addReceiptComment, {loading, error}) => {
            return (
              <Container className="general-container">
                <Row className="info-row">
                  <Col xs={6}>
                    <Row className="section-info">
                      <Panel title={`${t('popinDetails.receiptThumbnail')} : `}>
                        <TicketPreview receipt={receipt}/>
                      </Panel>
                    </Row>
                  </Col>
                  <Col xs={6}>
                    <Panel title={`${t('popinDetails.ticketReview')} : `}>
                      <Row>
                        {receipt.rating && <TicketRating receipt={receipt}/>}
                        {receipt.comments.length > 0 && (
                          <Col xs={12}>
                            <label className="mandatory-label">
                              <AttributeDiv className="label-name">{t('popinDetails.reviewUser')}</AttributeDiv>
                              <FullTextArea
                                disabled
                                value={receipt.comments.length > 0 ? receipt.comments[0].review : ''}
                                rows={7}
                              />
                            </label>
                          </Col>
                        )}
                      </Row>
                    </Panel>
                  </Col>
                </Row>
                {receipt.comments.length > 0 && (
                  <Panel title={`${t('popinDetails.merchantResponse')} : `}>
                    <Row>
                      <Col xs={12}>
                        <label className="mandatory-label">
                          <FullTextArea
                            disabled={receipt.comments.length > 1}
                            value={receipt.comments.length > 1 ? receipt.comments[1].review : responseMerchant}
                            onChange={e => setResponseMerchant(e.target.value)}
                            rows={7}
                          />
                        </label>
                        {!(receipt.comments.length > 1) && (
                          <div className="popin-buttons">
                            {error && (
                              <Error error={t('error')}/>
                            )}
                            <div>
                              <TitleButton
                                disabled={receipt.comments.length > 1 || loading}
                                onClick={() => postComment(addReceiptComment)}
                              >
                                {t('popinDetails.sendResponse')}
                              </TitleButton>
                            </div>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Panel>
                )}
              </Container>
            );
          }}
        </Mutation>
      </PopIn>
    </div>
  );
};

ReceiptDetailsReviewMerchant.propTypes = {
  t: PropTypes.func.isRequired,
  receipt: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
    file: PropTypes.object.isRequired,
    rating: PropTypes.number,
    comments: PropTypes.array.isRequired,
    brand: PropTypes.object.isRequired,
  }).isRequired,
};

export default withTranslation('ticket')(ReceiptDetailsReviewMerchant);
